import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonIcon, IonSkeletonText } from "@ionic/react"
import { ArticleSpecs } from "../../../models/articleModel"
import { useEffect, useState } from "react"
import { calculatorOutline, cartOutline, filterOutline } from "ionicons/icons"
import { ToolfinderFilterForm } from "./FormTypes"
import { getActiveFilterAmount } from "./FormHelpers"
import { useTranslation } from "react-i18next"

interface ResultCardProps {
    isCardShowing: boolean,
    result: ArticleSpecs[] | undefined,
    openFilterModal: (val: boolean) => void,
    loading: boolean,
    filter: ToolfinderFilterForm,
    matGroup: string | null,
    strategy: string | undefined,
    ap: number | string | undefined,
}

const ResultCard: React.FC<ResultCardProps> = ({ isCardShowing, result, openFilterModal, loading, filter, matGroup, strategy, ap }: ResultCardProps) => {
    const [filteredRes, setFilteredRes] = useState<ArticleSpecs[] | undefined>();
    const { t } = useTranslation();

    useEffect(() => {
        let ignore = false;
        let res = result?.filter((v, i, a) => a.findIndex(v2 => (v2.ident === v.ident && v2.pos === v.pos)) === i)

        if (!ignore) {
            setFilteredRes(res)
        }

        return () => { ignore = true }
    }, [result])


    if (isCardShowing) {
        return (
            <IonCard>
                <IonCardHeader>
                    <IonCardTitle>{t("toolfinder.ResultCard.title")}</IonCardTitle>

                </IonCardHeader>
                <IonCardContent>
                    {loading ? <div>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                            <div style={{ width: "calc(100% - 20px)" }}>
                                <IonSkeletonText animated={true} style={{ width: '75%' }}></IonSkeletonText>
                                <IonSkeletonText animated={true} style={{ width: '35%' }}></IonSkeletonText>
                            </div>
                            <IonSkeletonText animated={true} style={{ width: 40, height: 40 }}></IonSkeletonText>
                        </div>
                        <IonSkeletonText animated={true} style={{ height: 46 }}></IonSkeletonText>
                        <IonSkeletonText animated={true} style={{ height: 46 }}></IonSkeletonText>
                        <IonSkeletonText animated={true} style={{ height: 46 }}></IonSkeletonText>
                        <IonSkeletonText animated={true} style={{ height: 46 }}></IonSkeletonText>
                        <IonSkeletonText animated={true} style={{ height: 46 }}></IonSkeletonText>
                        <IonSkeletonText animated={true} style={{ height: 46 }}></IonSkeletonText>
                        <IonSkeletonText animated={true} style={{ height: 46 }}></IonSkeletonText>
                        <IonSkeletonText animated={true} style={{ height: 46 }}></IonSkeletonText>
                        <IonSkeletonText animated={true} style={{ height: 46 }}></IonSkeletonText>
                        <IonSkeletonText animated={true} style={{ height: 46 }}></IonSkeletonText>
                    </div> : <div>
                        {result === undefined && <p>{t("toolfinder.ResultCard.notFound")}</p>}
                        {filteredRes !== undefined &&
                            <div>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                                    <div>
                                        <div>{filteredRes.length} {t("toolfinder.ResultCard.amount")}.</div>
                                        {filter && <div>{getActiveFilterAmount(filter)} {t("toolfinder.ResultCard.filterAmount")}.</div>}
                                    </div>
                                    <IonButton onClick={() => openFilterModal(true)}>
                                        <IonIcon icon={filterOutline} slot="icon-only" />
                                    </IonButton>
                                </div>
                                {filteredRes.length > 0 && <table className="toolfinderResTable">
                                    <thead>
                                        <tr>
                                            <th>{t("toolfinder.ResultCard.article")}</th>
                                            <th>d<sub>1</sub></th>
                                            <th>l<sub>2</sub></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredRes.map(entry => <tr key={entry.ident + "-" + entry.pos}>
                                            <td>{entry.ident}-{entry.pos}</td>
                                            <td>{entry.d1}</td>
                                            <td>{entry.l2}</td>
                                            <td>
                                                <IonButton fill="clear" color={"dark"} routerLink={`/tabs/calculator/form/${entry.ident.replace(/\s+/g, '-')}/${entry.pos}/${matGroup}/${strategy}/${ap}`}>
                                                    <IonIcon slot="icon-only" icon={calculatorOutline} />
                                                </IonButton>
                                                <IonButton fill="clear" color={"dark"} target="_blank" rel="noreferrer" href={`https://hachenbach-toolshop.de/${entry.ident.replace(/ /g, "-").toLowerCase()}.html`}>
                                                    <IonIcon slot="icon-only" icon={cartOutline} />
                                                </IonButton>
                                            </td>
                                        </tr>)}
                                    </tbody>
                                </table>}
                            </div>}
                    </div>}

                </IonCardContent>
            </IonCard>
        )
    } else {
        return null
    }

}

export default ResultCard